import { tw } from '@/utils/tw';
import BaseRichTextBox from 'base/components/RichTextBox/theme';

const RichTextBox = tw.theme({
  extend: BaseRichTextBox,
  base: ['mx-auto', 'max-w-article'],
});

export default RichTextBox;
